import React from 'react';
import  { useNavigate } from 'react-router-dom'
import logoTVI from '../images/header/logo_thaivivat.svg'

function ThaivivatLogo() {
  const navigate = useNavigate();

  function gotoHome(){
    navigate("/", { replace: true })
  }
  
  return (
      <button onClick={gotoHome}><img  src={logoTVI} alt="logo Thaivivat" /></button>
  )
}

export default ThaivivatLogo;